import { render, staticRenderFns } from "./address-capture-point.vue?vue&type=template&id=2583e0ed&scoped=true&lang=pug&"
import script from "./address-capture-point.vue?vue&type=script&lang=js&"
export * from "./address-capture-point.vue?vue&type=script&lang=js&"
import style0 from "./address-capture-point.vue?vue&type=style&index=0&id=2583e0ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2583e0ed",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsFormsAddress: require('/home/ubuntu/nuxt/bonkers/releases/20230601152131/components/widgets/forms/address.vue').default,WidgetsFormsButton: require('/home/ubuntu/nuxt/bonkers/releases/20230601152131/components/widgets/forms/button.vue').default,SiteFeefoMini: require('/home/ubuntu/nuxt/bonkers/releases/20230601152131/components/site/feefo-mini.vue').default,ProductsPillCta: require('/home/ubuntu/nuxt/bonkers/releases/20230601152131/components/products/pill-cta.vue').default})
